import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { CardDescription } from '@/shared/ui/core';
import styles from './auth-card.module.scss';


export function AuthCardDescription ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
    return (
        <CardDescription
            className={ cn(styles.description, className) }
            data-template="auth-card-description"
            { ...props }
        />
    );
}
